import React from "react";
import { Container } from 'react-bootstrap';

import { Link } from 'react-router-dom';

import WOW from "wowjs";

class Hero extends React.Component {

	componentDidMount() {
    	new WOW.WOW().init();
  	}
  	render() {
		return (
			<div className="HereoBanner web">
			    <div className="Banner_Content">
					<Container fluid>
						<h2 className="pagehead-title wow fadeInUp">PHP WEB DEVELOPMENT</h2>
						<div className="red-border"> </div>
						<p>digiPanda is an offshore PHP development company in India that provides client-centric PHP development services & solutions, tailored to meet specifications of your business in a performance-rendering manner.</p>
						<Link to="/contact-us" className="red-btn"> GET FREE ESTIMATION </Link>
					</Container>
				</div>
			</div>
		);
	}
};

export default Hero;
